import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { Photos } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';

const ZeroStateItem = () => {
  return (
    <Flex
      width="100%"
      height={pxToRem(219)}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      borderRadius={3}
      border="1px dashed"
      borderColor="mono4"
      backgroundColor="mono1"
    >
      <Photos
        size={48}
        color="mono4"
      />
    </Flex>
  );
};

export const ZeroState: React.FC = () => {
  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(2, 1fr)"
      width="100%"
      gap={5}
    >
      {[...Array(4)].map((_, index) => (
        <ZeroStateItem key={index} />
      ))}
    </Box>
  );
};

ZeroState.displayName = 'ZeroState';
